module.exports = __webpack_public_path__ + "media/images/Ruler-ff68918f3ce7ac3b79801f69f640d83e.svg";